/* eslint-disable no-underscore-dangle */

import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { Provider as JotaiProvider } from 'jotai'

import { initialize } from './init'
import App from './App'
import { AppProvider } from './AppContext'

initialize()
  .then((result) => {
    const container = document.getElementById('root')
    const root = createRoot(container)
    const { store } = result

    if (!result) {
      container.innerHTML = 'Something went wrong'
      return
    }

    // window.roughSizeOfObject(store.getState())

    root.render(
      <Provider store={store}>
        <AppProvider value={{ store }}>
          <JotaiProvider>
            <App />
          </JotaiProvider>
        </AppProvider>
      </Provider>,
    )
  })
  .catch((error) => {
    console.error(error)
  })

window.roughSizeOfObject = (object) => {
  const objectList = []
  const stack = [object]
  let bytes = 0

  while (stack.length) {
    const value = stack.pop()

    if (typeof value === 'boolean') {
      bytes += 4
    } else if (typeof value === 'string') {
      bytes += value.length * 2
    } else if (typeof value === 'number') {
      bytes += 8
    } else if (typeof value === 'object' && objectList.indexOf(value) === -1) {
      objectList.push(value)

      for (const i in value) {
        stack.push(value[i])
      }
    }
  }

  return bytes
}
